import { WarningOutlineIcon } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FEEDBACK_TYPES } from '../../../../../constants/errorConstants';
import SystemFeedback from '../../../../common/Exception/ExceptionFeedback';

const ProductSystemFeedback = ({
  indirectReplacement,
  replacementParts = [],
  isPackage = false,
  isCustomizable = false
}) => {
  const [t] = useTranslation();
  const isOneToOneReplacement = replacementParts?.length === 1;
  const isOneToManyReplacement = replacementParts?.length > 1;

  let message;

  const kitMessageBuilder = messages => {
    const fomattedMessages = Array.isArray(messages)
      ? messages.map((msg, index) =>
          index === 0 ? (
            <p key={`${index}-kit-message`} className="m-0 fw-bold">
              {msg}
            </p>
          ) : (
            <p key={`${index}-kit-message`} className="m-0">
              {msg}
            </p>
          )
        )
      : messages;
    return <>{fomattedMessages}</>;
  };

  const getKitMessage = () => {
    return isCustomizable
      ? kitMessageBuilder([
          t('CUSTOMIZABLE_AND_UNAVAILABLE_KIT_MESSAGELINE1'),
          t('CUSTOMIZABLE_AND_UNAVAILABLE_KIT_MESSAGELINE2')
        ])
      : kitMessageBuilder([
          t('NONCUSTOMIZABLE_AND_UNAVAILABLE_KIT_MESSAGELINE1'),
          t('NONCUSTOMIZABLE_AND_UNAVAILABLE_KIT_MESSAGELINE2')
        ]);
  };

  if (indirectReplacement) {
    message = isPackage
      ? getKitMessage()
      : `${t('INDIRECT_REPLACE_PDP')} ${t('INDIRECT_REPLACE_PDP2')}`;
  } else if (isOneToOneReplacement) {
    message = t('REPLACED_PART');
  } else if (isOneToManyReplacement) {
    message = t('1M_REPLACED_PART');
  }

  return message ? (
    <SystemFeedback
      icon={WarningOutlineIcon}
      preventScroll
      type={FEEDBACK_TYPES.WARNING}
    >
      <p className="pb-3">{message}</p>
    </SystemFeedback>
  ) : null;
};

ProductSystemFeedback.propTypes = {
  indirectReplacement: PropTypes.bool,
  isPackage: PropTypes.bool,
  isCustomizable: PropTypes.bool,
  replacementParts: PropTypes.arrayOf(
    PropTypes.shape({
      uniqueId: PropTypes.string
    })
  )
};

export default ProductSystemFeedback;
